import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { Edit, Payment } from '@mui/icons-material';
import type { Participant } from '../../../../shared/services/visitors/visitorService';
import { PaymentConfirmation } from './PaymentConfirmation';
import { Can } from '../../../../shared/components/Permission';
import { useToast } from '../../../../shared/hooks/useToast';

interface ActionButtonsProps {
  participant: Participant;
  onEdit: (participant: Participant) => void;
}

export function ActionButtons({ participant, onEdit }: ActionButtonsProps) {
  const { showToast } = useToast();
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const handleCopyPublicPaymentLink = () => {
    const frontendUrl = import.meta.env.VITE_FRONTEND_URL || window.location.origin;
    const link = `${frontendUrl}/public/event/${participant.event_id}/payment`;
    navigator.clipboard.writeText(link);
    showToast('Link de pagamento copiado! Passe para o participante.', 'success');

  };

  return (
    <>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ width: '100%', flex: 1, p: { xs: 0, sm: 2 } }}
      >
        <Can roles={['ADMIN']}>
          <Button
            variant="outlined"
            startIcon={<Edit />}
            onClick={() => onEdit(participant)}
            fullWidth
          >
            Editar
          </Button>

          {participant.payment_status === 'open' && (
            <Button
              variant="contained"
              color="success"
              startIcon={<Payment />}
              onClick={() => setShowPaymentDialog(true)}
              fullWidth
            >
              Confirmar Pagamento
            </Button>
          )}
        </Can>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={handleCopyPublicPaymentLink}
          fullWidth
        >
          Link 2 via do Pagamento
        </Button> */}
      </Stack>

      <PaymentConfirmation
        participantId={participant.id}
        isOpen={showPaymentDialog}
        onClose={() => setShowPaymentDialog(false)}
        onSuccess={() => {

        }}
      />
    </>
  );
}